import React from 'react';
import { Action, ActionList } from './models';

export default function ActionBar({ actions }: { actions: ActionList }) {
    return <div style={{ display: 'flex' }}>{actions.map((action: Action, index: number) => action)}</div>;
}
